<template>
  <v-app>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="800" :value="true" color="warning" absolute outlined top right>
      <v-icon class="mr-2" color="warning">mdi-alert-outline</v-icon>
      {{ errMsg }}
      <v-icon @click="snackbar = false" class="float-right" color="warning">mdi-close-circle</v-icon>
    </v-snackbar>
    <v-container class="pa-0 pa-sm-3 pa-md-3">
      <div class="px-sm-4">
        <v-toolbar dense class="elevation-0 mb-4 mt-6 pr-4">
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold headline">Expenses</v-list-item-title>
                <v-list-item-subtitle class="body-1 mb-0 mt-1" color="#878B93"> An expense refers to the amount of money spent on something. </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y>
            <template v-slot:activator="{on, attrs}">
              <v-text-field color="#3B82F6" class="rounded-lg mt-2" style="max-width: 180px" outlined dense hide-details v-model="date" label="Month" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker color="#3B82F6" :max="latest" @change="monthChange()" v-model="date" type="month" no-title scrollable> </v-date-picker>
          </v-menu>
        </v-toolbar>

        <div class="pa-4">
          <v-card outlined>
            <v-progress-linear color="#3B82F6" v-if="!expenses.loader" indeterminate></v-progress-linear>
            <v-list flat dense class="py-0" v-if="expenses && expenses.Total">
              <div v-for="(q, w, e) in expenses" :key="e">
                <v-list-item v-if="w != 'loader'">
                  <v-list-item-content>
                    <v-list-item-subtitle>{{ w }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content class="text-right">
                    <v-list-item-title :class="w != 'Total' ? 'font-weight-bold' : 'font-weight-black'">&#8377; {{ q ? Number(q).toFixed(2) : "0.00" }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </div>
            </v-list>
            <div v-else class="py-16 text-center">No expense data for {{new Date(date).toLocaleString('default', { month: 'long', year: '2-digit' })}}</div>
          </v-card>
        </div>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import {apiurl} from "../apiUrl";
import axios from "axios";

export default {
  data() {
    return {
      snackbar: false,
      errMsg: "",

      branchcode: null,

      date: new Date().toISOString().substr(0, 7),
      past: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 7),

      latest: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),

      expenses: [],
    };
  },
  created() {
    let modeis = localStorage.getItem("mode");
    if (modeis == "RM") {
      this.$router.push("/dashboard");
    } 
    this.branchcode = localStorage.getItem("brcode");
  },

  mounted() {
    this.getExpenses();
  },

  methods: {
    getExpenses() {
      this.expenses = [];
      let data = JSON.stringify({
        type: "view",
        Month: this.date,
        Branch_code: this.branchcode,
      });

      let config = {
        method: "post",
        url: `${apiurl}/expenses`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data && response.data.Total_expenses) {
            axiosThis.expenses = response.data;
            delete axiosThis.expenses["Manager_name"];
            delete axiosThis.expenses["Branch_code"];
            delete axiosThis.expenses["Month"];
            axiosThis.expenses["Total"] = axiosThis.expenses["Total_expenses"];
            delete axiosThis.expenses["Total_expenses"];
          } else {
            axiosThis.snackbar = true;
            axiosThis.snakclr = "error";
            axiosThis.errMsg = response.data.msg;
          }
          axiosThis.expenses.loader = [0];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    monthChange() {
      this.$refs.menu.save(this.date);
      this.getExpenses();
    },
  },
};
</script>
